import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { IauthState } from "./auth.types";

const selectDomain = (state: any) => state.authReducer;

export const user = createDraftSafeSelector(
  selectDomain,
  (user: IauthState) => user.auth
);

export const loginSuccessMessage = createDraftSafeSelector(
  selectDomain,
  (user: IauthState) => user.loginSuccessMesssage
);

export const error = createDraftSafeSelector(
  selectDomain,
  (user: IauthState) => user.error
);

export const activityInProcess = createDraftSafeSelector(
  selectDomain,
  (user: IauthState) => user.isActivityInProcess
);

export const validToken = createDraftSafeSelector(
  selectDomain,
  (user: IauthState) => user.isValidToken
);

export const tokenMessage = createDraftSafeSelector(
  selectDomain,
  (user: IauthState) => user.tokenMessage
);
